import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  ButtonComponent,
  ButtonItemTemplateDirective,
  SplitButtonComponent,
} from '@progress/kendo-angular-buttons';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import {
  CellTemplateDirective,
  CheckboxColumnComponent,
  ColumnComponent,
  GridComponent,
  SelectionDirective,
} from '@progress/kendo-angular-grid';
import { AdminLayoutModule } from '../../admin-layout/admin-layout.module';
import { ClickOutsideDirective } from '../../core/directives/click-outside.directive';
import { TimeFormatPipe } from '../../core/pipes/time-format.pipe';
import { FeaturesModule } from '../../features/features.module';
import { SharedModule } from '../../shared/shared.module';
import { TimeEntriesCalendarViewComponent } from './time-entries-calendar-view/time-entries-calendar-view.component';
import { TimeEntriesListViewComponent } from './time-entries-list-view/time-entries-list-view.component';
import { TimeTrackingComponent } from './time-tracking.component';

@NgModule({
  declarations: [
    TimeTrackingComponent,
    TimeEntriesListViewComponent,
    TimeEntriesCalendarViewComponent,
  ],
  imports: [
    CommonModule,
    RouterOutlet,
    FeaturesModule,
    AdminLayoutModule,
    ButtonComponent,
    CellTemplateDirective,
    CheckboxColumnComponent,
    ColumnComponent,
    DropDownListComponent,
    GridComponent,
    SelectionDirective,
    SharedModule,
    ClickOutsideDirective,
    SplitButtonComponent,
    ButtonItemTemplateDirective,
    TimeFormatPipe,
  ],
})
export class TimeTrackingModule {}
